<template>
  <a
    href="#"
    class="nav-link font-weight-bold text-white"
    @click.prevent="abrirSolicitudSoporte"
  >
    <i class="fas fa-headset mr-1"></i>Solicitud soporte
  </a>
</template>

<script>
const VIGENCIA_SEGUNDOS = 1 * 86400; // 1 día
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PLATAFORMA_RE = /^[A-Za-z0-9_-]{2,20}$/;

function bytesABinario(bytes) {
  let binario = "";
  for (let i = 0; i < bytes.length; i++) {
    binario += String.fromCharCode(bytes[i]);
  }
  return binario;
}

function codificarTokenAcceso(payload) {
  const json = JSON.stringify(payload);
  const bytes = new TextEncoder().encode(json);
  return btoa(bytesABinario(bytes))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
}

function normalizarUrlSoporte(raw) {
  let valor = String(raw || "").trim();
  if (!valor) {
    return { error: "Falta VUE_APP_SUPPORT724_URL en el entorno." };
  }
  valor = valor.replace(/\/+$/, "").replace(/\/EnviarTicket$/i, "").replace(/\/+$/, "");
  try {
    const parsed = new URL(valor);
    if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
      return { error: "VUE_APP_SUPPORT724_URL debe ser una URL http o https." };
    }
  } catch (e) {
    return { error: "VUE_APP_SUPPORT724_URL no es una URL válida." };
  }
  return { url: valor };
}

function validarEmail(email) {
  return EMAIL_RE.test(String(email || "").trim());
}

function validarCodigoPlataforma(codigo) {
  return PLATAFORMA_RE.test(String(codigo || "").trim());
}

function urlEnviarTicket(baseSoporte, datos) {
  const ahora = Math.floor(Date.now() / 1000);
  const payload = {
    iat: ahora,
    exp: ahora + VIGENCIA_SEGUNDOS,
    plataforma: datos.plataforma,
    cliente: datos.cliente || null,
    user: datos.user,
    email: datos.email,
  };
  const token = codificarTokenAcceso(payload);
  return `${baseSoporte}/EnviarTicket?token=${encodeURIComponent(token)}`;
}

export default {
  name: "SolicitudSoporteNavLink",
  computed: {
    usuario() {
      return this.$store.state.user;
    },
    urlSupport724() {
      return String(process.env.VUE_APP_SUPPORT724_URL || "").trim();
    },
    codigoPlataforma() {
      return String(process.env.VUE_APP_SUPPORT724_PLATAFORMA || "").trim();
    },
    clientePlataformaActual() {
      const cid = this.$store.getters.getCurrentClientePlataformaId;
      const clientes =
        (this.usuario &&
          (this.usuario.clientes_plataforma ||
            this.usuario.clientesPlataforma)) ||
        [];
      if (cid == null || !Array.isArray(clientes)) {
        return null;
      }
      return clientes.find((c) => Number(c.id) === Number(cid)) || null;
    },
    datosSolicitud() {
      const cliente = this.clientePlataformaActual;
      return {
        user: String((this.usuario && this.usuario.name) || "").trim(),
        email: String((this.usuario && this.usuario.email) || "").trim(),
        cliente: (cliente && String(cliente.nombre || "").trim()) || null,
        plataforma: this.codigoPlataforma,
      };
    },
  },
  methods: {
    avisoError(titulo) {
      this.$swal({
        icon: "error",
        title: titulo,
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true,
      });
    },
    erroresSolicitud() {
      const errores = [];
      const base = normalizarUrlSoporte(this.urlSupport724);
      if (base.error) {
        errores.push(base.error);
      }
      const { user, email, plataforma } = this.datosSolicitud;
      if (!plataforma) {
        errores.push("Falta VUE_APP_SUPPORT724_PLATAFORMA en el entorno.");
      } else if (!validarCodigoPlataforma(plataforma)) {
        errores.push("VUE_APP_SUPPORT724_PLATAFORMA no tiene un código válido.");
      }
      if (!user) {
        errores.push("Falta el nombre del usuario en sesión.");
      }
      if (!email) {
        errores.push("Falta el correo del usuario en sesión.");
      } else if (!validarEmail(email)) {
        errores.push("El correo del usuario en sesión no es válido.");
      }
      return { errores, baseUrl: base.url || null };
    },
    abrirSolicitudSoporte() {
      const { errores, baseUrl } = this.erroresSolicitud();
      if (errores.length > 0) {
        this.avisoError(errores[0]);
        return;
      }

      const { user, email, cliente, plataforma } = this.datosSolicitud;
      let url;
      try {
        url = urlEnviarTicket(baseUrl, { user, email, cliente, plataforma });
      } catch (e) {
        this.avisoError("No se pudo generar el enlace de solicitud de soporte.");
        return;
      }

      const ventana = window.open(url, "_blank", "noopener,noreferrer");
      if (!ventana) {
        this.avisoError(
          "El navegador bloqueó la ventana. Permita ventanas emergentes e intente de nuevo."
        );
      }
    },
  },
};
</script>
